import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Deposit, DepositRequest, DepositResponse } from './types'
import { transactionRequestDirection } from '../../const'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const DATE_FIELDS = ['updatedAt', 'createdAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (key === 'transactionId') {
    return ['id', value?.toLowerCase()]
  }

  if (key === 'client') {
    return ['client.email', value?.toLowerCase()]
  }

  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const depositsListMounted = createEvent<DepositRequest>()

export const getDeposits = fx<DepositRequest, DepositResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const $deposits = restore<Deposit[]>(
  getDeposits.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfDeposits = restore(
  getDeposits.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: depositsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    query['where'] = `{"direction": "` + transactionRequestDirection.In() + `"}`

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          if (key === 'isAuto') {
            const val = filters[key as keyof typeof filters]
            accumulator[key] = Array.isArray(val) && val.length > 0
              ? String(val[0])
              : val
          } else {
            accumulator[key as keyof typeof filters] =
              key === 'status' ||
              key === 'initialCurrency' ||
              key === 'clientCurrency' ||
              key === 'product' ||
              key === 'transactionType'
                ? filters[key as keyof typeof filters]
                : `${filters[key as keyof typeof filters]}`
          }
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      newObj['direction'] = transactionRequestDirection.In()

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getDeposits,
})
